<template>
  <div>
    <div v-if="this.$route.query.type=='ispcloud'">
      <div class="app1">
        <keep-alive>
          <router-view />
        </keep-alive>
      </div>
    </div>
    <div v-else-if="this.$route.query.id">
      <div class="app">
        <ArticleContent :id="this.$route.query.id" />
      </div>
      <div class="macc">
        <div id="nav">
          <HeadMenu />
        </div>
        <keep-alive>
          <router-view />
        </keep-alive>
        <div id="foot">
          <FootLogo />
        </div>
      </div>
    </div>
    <div v-else>
        <div id="nav">
          <HeadMenu />
        </div>
        <keep-alive>
          <router-view />
        </keep-alive>
        <div id="foot">
          <FootLogo />
        </div>
    </div>
  </div>
</template>

<script>
import HeadMenu from "@/components/HeadMenu.vue";
import FootLogo from "@/components/FootLogo.vue";
// 适配移动端，小屏直接显示文章
import ArticleContent from "@/views/ArticleContent.vue";
import { initStatisticsComp } from '@/utils/statisticsMgr.js';
export default {
  components: {
    HeadMenu,
    FootLogo,
    ArticleContent,
  },
  watch: {
    $route(to, from) {
      if (to.path.includes('/isp')) {
        sessionStorage.setItem("isIsp", true);
      }  else if (to.path === '/') { 
        sessionStorage.setItem("isIsp", false);
      }
    }
  },
  mounted() {
    initStatisticsComp();
    let sessionID = window.sessionStorage.activeId;
    let localID = window.localStorage.activeId;
    localID = localID ? localID : "游客";
    let userid = sessionID ? sessionID : localID;
    this.GLOBAL.userid = userid;
    console.log("this.GLOBAL", this.GLOBAL);

    if (this.$route.path.includes('/isp')) {
      sessionStorage.setItem("isIsp", true);
    } else if (this.$route.path === '/' && location.href.endsWith('help/#/')) { 
      sessionStorage.setItem("isIsp", false);
    }
  },
  beforeDestroy() {
    console.log(
      "macc-help-文档中心-用户统计,this.GLOBAL.count",
      this.GLOBAL.count
    );
    // 发送诸葛io埋点数据
    this.zhugePoint("macc-help-文档中心-用户统计", {
      userid: this.GLOBAL.userid, //用户id
      enterTime: this.GLOBAL.enterTime, //用户进入文档系统的时间
      outTime: new Date(), //用户离开文档系统的时间
      count: this.GLOBAL.count, //全局阅读文章数
    });
  },
};
</script>
<style lang="scss">
// 覆盖组件库和 Markdown 预览的默认蓝色，统一使用主题变量。
a,
.github-markdown-body a,
.ant-anchor .ant-anchor-link-active > .ant-anchor-link-title {
  color: var(--theme-color);
}
a:hover,
.ant-anchor .ant-anchor-link-title:hover,
.github-markdown-body a:hover,
.ant-breadcrumb a:hover {
  color: var(--theme-hover);
}
a:active,
.ant-anchor .ant-anchor-link-title:active,
.github-markdown-body a:active {
  color: var(--theme-active);
}
.ant-input:hover,
.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: var(--theme-hover);
}
.ant-input:focus {
  border-color: var(--theme-focus);
  box-shadow: 0 0 0 2px var(--theme-light);
}
.ant-anchor-ink-ball {
  border-color: var(--theme-color);
}
::selection {
  background: var(--theme-color);
  color: var(--text-white-title);
}
@media screen and (max-width: 1000px) {
  .macc {
    display: none !important;
  }
  .app {
    width: 100vw;
  }
}
@media screen and (min-width: 1101px) {
  .app {
    display: none !important;
  }
}
.warper {
  // width: 68vw;
  // min-width: 1200px !important;
  // max-width: 1377px;
  max-width: 1200px;
  margin: 0px auto;
}
.hoverColor:hover {
  color: var(--theme-color) !important;
}
.pointer {
  cursor: pointer;
}
html::-webkit-scrollbar {
  width: 5px;
}
.html::-webkit-scrollbar-track {
  background: var(--gray-4);
  border-radius: 5px;
}
.html::-webkit-scrollbar-thumb {
  background: var(--gray-6);
  border-radius: 5px;
}
.html::-webkit-scrollbar-thumb:hover {
  background: var(--gray-6);
  border-radius: 5px;
}
.html::-webkit-scrollbar-thumb:active {
  background: var(--gray-8);
  border-radius: 5px;
}
</style>
